import ExamImage from "../../components/ExamImage";
export default function AnalysisInverseWidget({
  definitions = [],
  pieces = [],
  value = {},
  feedback = null,
  onChange,
  mode = "edit"
}) {
  function setAnswer(id, v) {
    if (mode !== "edit") return;
    const letter = v.toUpperCase().replace(/[^ABCD]/g, "");
    onChange({ ...value, [id]: letter });
  }

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 32 }}>

      {/* DEFINITIONS */}
      <div style={{ display: "grid", gap: 12 }}>
        {definitions.map((d) => (
          <div key={d.id} style={{ display: "flex", gap: 12 }}>
            <strong style={{ width: 24 }}>{d.id}.</strong>
            <span>{d.text}</span>
          </div>
        ))}
      </div>

      {/* PIECES */}
      <div style={{ display: "grid", gap: 24 }}>
        {pieces.map((p) => {
          const part = feedback?.parts?.[p.id];
          const isCorrect = part?.correct;

          return (
            <div
              key={p.id}
              style={{
                display: "grid",
                gridTemplateColumns: "48px 1fr",
                gap: 16
              }}
            >
              {/* INPUT */}
              <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                <input
                  type="text"
                  maxLength={1}
                  value={value[p.id] || ""}
                  onChange={(e) => setAnswer(p.id, e.target.value)}
                  style={{
                    width: 40,
                    height: 40,
                    fontSize: 18,
                    textAlign: "center",
                    border: `2px solid ${
                      part
                        ? isCorrect
                          ? "#2e7d32"
                          : "#c62828"
                        : "#333"
                    }`,
                    borderRadius: 6
                  }}
                />

                {/* FEEDBACK
                {part && (
                  <div
                    style={{
                      fontSize: 13,
                      marginTop: 6,
                      color: isCorrect ? "#2e7d32" : "#c62828"
                    }}
                  >
                    {isCorrect ? "✓" : `✗ → ${part.expected}`}
                  </div>
                )} */}
              </div>

              {/* IMAGE + TITLE */}
              <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
                <div style={{ fontWeight: 600 }}>{p.title}</div>
                {p.src && (
                  <ExamImage
                    src={p.src}
                    alt={p.title}
                    style={{
                      width: 700,
                      border: "1px solid #ccc",
                      borderRadius: 6
                    }}
                  />
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
